/**
 * @package     Blueacorn\Modal
 * @version     2.0
 * @author      Blue Acorn <code@blueacorn.com>
 * @copyright   Copyright © 2015 Blue Acorn.
 */

function Modal(options) {
    this.init(options);
}

(function ($) {

    Modal.prototype = {
        init: function (options) {
            this.setupObservers();
        },

        setupObservers: function(){
            function init()
            {
                //Append modal overlay
                $("body").append('<div class="modal-overlay"></div>');
                //Append modal content
                $("body").append('<div class="modal-wrapper"><div class="modal-content"></div></div>');
                
                $(document).delegate('.video-image-macro, .video-image-micro','click',_open);
                $(document).delegate('.close-btn, .modal-overlay','click',_close);
                $(document).delegate('.close-video-btn','click',function(){
                    $(this).parent().parent().find('a').show();
                    $(this).parent().remove();
                });
            }

            function updateVideoContent(elem) {
                var vidUrl = elem.attr("href");
                var iFrame = '<div class="video-wrapper"><div class="video-iframe ratio-16-9"><iframe src="' + vidUrl + '" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div></div>';
                 if (CorraUI.isDesktop() && (elem.parent().hasClass("module-2x") || elem.parent().hasClass("module-3x"))) {
                    elem.parent().append(iFrame);
                    elem.parent().find(".video-iframe").before('<a class="close-video-btn" title="Close" href="javascript:;">Close</a>');
                    elem.parent().find(".video-wrapper").hide();
                    elem.hide();
                }else {
                $(".modal-content").html(iFrame);
                try{
                    //ytTracker.init();
                }
                catch (err) {
                    console.log(err.message);
                }
            }
            }

            function _open($evt)
            {
                $evt.preventDefault();
                updateVideoContent($(this));

                if ($(window).width() <= 600)
                {
                    // $( 'body' ).scrollTop( 0 );
                } else
                {
                    $('body').css('overflow', 'hidden');
                }
                
                if (!CorraUI.isTouch() & CorraUI.isDesktop() && ($(this).parent().hasClass("module-2x") || $(this).parent().hasClass("module-3x"))) {
                    $('body').removeAttr('style');
                    modal = $(this).parent().find(".video-wrapper");
                    modal.show();
                    //ytTracker.init();
                } else {
                    $('.modal-overlay').on('transitionend', _onOpenTransitionEnd);
                    $('.modal-overlay, .modal-wrapper').addClass('visible');
                    $('.modal-wrapper .btn').css('display', 'inline-block');
                }
                return false;
            }

            function _close($evt)
            {
                $evt.preventDefault();

                if ($(window).width() > 600)
                {
                    $('body').css('overflow', '');
                }
                
                $('.modal-wrapper').on('transitionend', _onCloseTransitionEnd);
                $('.modal-overlay, .modal-wrapper').removeClass('visible');
                $(".modal-content").html("");
            }

            function _onOpenTransitionEnd($evt)
            {
                $(this).off('transitionend');
               // $('.modal-wrapper .btn').css('display', 'inline-block');
              //  $('.modal-wrapper').addClass('visible');
            }

            function _onCloseTransitionEnd($evt)
            {
                $(this).off('transitionend');
                
            }
            init();
        }
    };

    /**
     * The parameter object is optional.
     * Must be an object.
     */
    Modal = new Modal({});

})(jQuery);

